import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
} from "utils/helpers";

const queryFn = (accessToken: string, buildingModelCarbonReductionPlanId: string) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: { buildingModelCarbonReductionPlanId },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data.buildingModelCarbonReductionPlanReports.error)
            throw new Error(data.buildingModelCarbonReductionPlanReports.error);

        return data
                .buildingModelCarbonReductionPlanReports
                ?.annualCarbonEmissionsNaturalGasChart?.map(
            (item) => {
                const endUses: { [endUseKey: string]: number } = {};
                const year = item?.year || 0;
                item?.endUseCarbonEmissions.forEach((use) => {
                    const endUseKey = use?.endUse;
                    const carbonEmissions = use?.carbonEmissions || 0;
                    if (endUseKey) endUses[endUseKey] = carbonEmissions;
                });
                return {
                    year,
                    ...endUses,
                };
            }
        );
    });

const query = graphql(`
    query buildingBaselineAnnualCarbonEmissionsNaturalGasChart(
        $buildingModelCarbonReductionPlanId: Uuid!
    ) {
        buildingModelCarbonReductionPlanReports(buildingModelCarbonReductionPlanId: $buildingModelCarbonReductionPlanId) {
            error
            annualCarbonEmissionsNaturalGasChart {
                year
                endUseCarbonEmissions {
                    endUse
                    carbonEmissions
                }
            }
        }
    }
`);

export default queryFn;
